import React from "react";
import "./styles.scss";
import "./mobile.scss";
import NullishSpan from "../../nullish-span/NullishSpan";

const Index = (props) => (
  <>
    <div className={`cfm-inner-content ${props.option}`}>
      <div className={`cfm-content-title`}>{props.title}</div>

      <div className={`cfm-content-body`}>
        <NullishSpan value={props.content} />
      </div>
    </div>
  </>
);

export default Index;
